var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticStyle:{"max-width":"70px"}},[_c('FrSpinner',{attrs:{"size":"xs"}})],1):_c('BBadge',{attrs:{"pill":"","variant":_vm.execution.status === 'ACTIVE' ? 'warning'
    : _vm.execution.status === 'FAILED' || _vm.execution.status === 'CANCELLED' ? 'danger'
      : _vm.execution.status === 'SUCCEEDED' ? 'success'
        : 'light'}},[_c('span',{staticClass:"text-capitalize"},[_vm._v(" "+_vm._s(_vm.getStatusLabel(_vm.execution.status))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }